var $ = require('../../../jCube');

exports.controlSelect = {

    build: function(_data) {
        // console.log(_data);
        return $.assign({}, _data, {
            tagName: 'select',
            // className: 'select',
            container: {
                className: 'fb-select'
            },
            render: this.render
        });
    },

    render: function(dom) {

        var option;

        if(!$.isEmptyValue('values', this)) {
            for (var i = 0; i < this.values.length; ++i){
                if(this.values[i] !== null) {
                    var item = this.values[i];
                    option = document.createElement('option');
                    option.setAttribute('value', item.value);
                    option.text = item.label;

                    dom.appendChild(option);
                }
            }
        }

        return dom;
    }
};
